// Module name
export const MODULE_NAME = 'inject';

export let global_vars = {};

// takes any markup like this:
// <div class="js-inject" data-greeting="Hello" data-place="World">
//     {{greeting}} {{place}}!
// </div>
//
// And transforms it into this:
// <div class="js-inject" data-greeting="Hello" data-place="World">
//     Hello World!
// </div>
export function initialize(global) {
    let doc = global.document;
    let all_inject = doc.querySelectorAll('.js-inject');
    for (let instance of all_inject) {
        let text;
        let is_input = instance.matches('input');
        if (is_input) {
            text = instance.getAttribute('value');
        } else {
            text = instance.innerHTML;
        }

        let all_names = text.match(/{{\s*[\w.]+\s*}}/g);
        if (all_names) {
            all_names = all_names.map(x => {
                return x.match(/[\w.]+/)[0];
            });
            for (let name of all_names) {
                let regex = new RegExp(`{{${name}}}`, 'gm');
                let newval = instance.dataset[name] || '';
                text = text.replace(regex, newval);
            }
        }

        if (is_input) {
            instance.setAttribute('value', text);
        } else {
            instance.innerHTML = text;
        }
        instance.classList.add('js-inject--processed');
    }
}
